import { BuyBulkTicketProps } from "./types";
import Slider from "shared/components/slider";
import useBuyBulkTicketService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import BulkTicketPayment from "./components/bulkTicketPayment";
import BulkTicketQuantity from "./components/bulkTicketQuantity";
import BulkTicketPurchaseConfirmation from "./components/bulkTicketPurchaseConfirmation";

export default function BuyBulkTicket(props: BuyBulkTicketProps) {
  const copies = useCopies();
  const service = useBuyBulkTicketService(props);

  return (
    <Slider
      handleClose={props.closeHandler}
      title={
        <span>
          {copies.get("buy.more.bulk.ticket")}
          {props.ticketFormName && <span className="buyBulkTicketsSubHeader">({props.ticketFormName})</span>}
        </span>
      }
      className="buyBulkTicketsSlider">
      {service.state.stepNo === 1 && <BulkTicketQuantity service={service} ticketFormId={props.ticketFormId} />}
      {service.state.stepNo === 2 && <BulkTicketPayment service={service} ticketFormName={props.ticketFormName} />}
      {service.state.stepNo === 3 && (
        <BulkTicketPurchaseConfirmation service={service} closeHandler={props.closeHandler} />
      )}
    </Slider>
  );
}
